import { render, staticRenderFns } from "./TrancheList.vue?vue&type=template&id=f5accc5e&"
import script from "./TrancheList.vue?vue&type=script&lang=js&"
export * from "./TrancheList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports